import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { brokeredPreviewStorage } from "./previewAuthStorage";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "@/lib/config";
import { toast } from "sonner";
import {
  MENSAJE_SOLO_LECTURA,
  crearAvisoSinRafaga,
  detalleSoloLectura,
  crearFetchSoloLectura,
} from "@/lib/impersonation/solo-lectura";
import { crearFetchVerComo } from "@/lib/impersonation/ver-como-lectura";

// "Ver como" = solo lectura en toda la app: mientras hay un impersonado publicado
// se rechazan las escrituras REST a tablas y de Storage (las RPC y Edge Functions
// pasan: el back las valida con la sesión real). Ver `lib/impersonation/solo-lectura`.
/** Toast único del bloqueo; también lo usan las subidas por XHR que no pasan por este fetch. */
export const avisarSoloLecturaVerComo = crearAvisoSinRafaga(() =>
  toast.error(MENSAJE_SOLO_LECTURA, { id: "solo-lectura-ver-como", description: detalleSoloLectura() }),
);
// Debajo, el header `x-ver-como` para que las RPC de lectura de Cobranza y Productos respondan
// con el acceso de la persona impersonada (ver `lib/impersonation/ver-como-lectura`).
const fetchSoloLectura = crearFetchSoloLectura({
  base: crearFetchVerComo(),
  alBloquear: () => avisarSoloLecturaVerComo(),
});

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
console.log("Debug - SUPABASE_URL:", SUPABASE_URL);
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  },
  global: { fetch: fetchSoloLectura },
});
